import Cookies from 'js-cookie';



const url=process.env.REACT_APP_ENV==="production"?"https://hrmanagement.zorvas.com":process.env.REACT_APP_API_URL

const ragUrl=process.env.REACT_APP_ENV==="production"?"https://hrmanagement.zorvas.com":process.env.REACT_APP_API_RAGURL


async function ProfileSetupFetch(data,profileData)
{
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    profileData.forEach((value, key) => {
        formData.append(key, value);
      });
  
    try
    {
      const response=await fetch(`${url}/api/profile/profilesetup`,{method:'POST',
        headers: {
          'Authorization': `Bearer ${Cookies.get('token') || ''}`, 
        },
        body:formData});

      if(response.ok)
      {
        const data=await response.json();
        sessionStorage.setItem("profileImage",data.data.profileImage);
        return data;
      }
      else
      {
        const error=await response.json();
        return `${error}`;
      }
     
    }
    catch(error)
    {
       return { success: false, error: error.message };
    }
}


const fetchProfile=async ()=>{
  try{
    const response=await fetch(`${url}/api/profile/profileSetupCompleted?userid=${Cookies.get('id')}`,{headers:{
      'Authorization': `Bearer ${Cookies.get('token')}`, 
    },});
    if(response.ok)
    {
      const data=await response.json();
      return data;
    }
    const error=await response.json();
    return error;
  }
  catch(error)
  {
     return { success: false, error: error.message };
  }
}

const fetchRoles=async ()=>{
  try{
    const response=await fetch(`${ragUrl}/api/admin/ragQA/roles`);
    
    return response.json();
  }
  catch(error)
  {
     return { success: false, error: error.message };
  }
}
const fetchDomains=async ()=>{
  try{
    const response=await fetch(`${ragUrl}/api/admin/ragQA/domains`);
    
    console.log('res',response);
    return response.json();
  }
  catch(error)
  {
     return { success: false, error: error.message };
  }
}
const fetchExperiences=async ()=>{
  try{
    const response=await fetch(`${ragUrl}/api/admin/ragQA/experiences`);
    
    console.log('res',response);
    return response.json();
  }
  catch(error)
  {
     return { success: false, error: error.message };
  }
}


export {ProfileSetupFetch,fetchProfile,fetchRoles,fetchDomains,fetchExperiences};